export default __webpack_public_path__ + "static/media/cardL.8de110e9.png";